import { CommonModule } from '@angular/common'
import { Component, Input, inject, computed } from '@angular/core'

import {
  MarkdownComponent,
  TypographyComponent,
  TypographyVariant,
} from '@hyperkit'

import { SessionService } from '@hunt/services'

@Component({
  standalone: true,
  imports: [CommonModule, TypographyComponent, MarkdownComponent],
  selector: 'report-text-block',
  templateUrl: './report-text-block.component.html',
  styleUrls: ['./report-text-block.component.scss'],
})
export class ReportTextBlockComponent {
  @Input() public title = ''
  @Input() public variant: TypographyVariant = 'h4'
  @Input() public value = ''
  @Input() height: string | number = '100%'
  readonly session = inject(SessionService)
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )

  get editorHeight(): string {
    return typeof this.height === 'number' ? `${this.height}px` : this.height
  }
}
